/**
 * Created by zuozhuo on 2018/1/30.
 */
import foStorage from "../utils/foStorage";
import { STORAGE_KEYS } from "../consts/consts";
import utils from "../utils/utils";

const cryptKey = "2fcp9iw51LJTaXgJGmqKY8IS3qbAPz8E";

function foAjaxEncode(data, encodeUrl = true) {
  let _str = JSON.stringify(data);
  if (encodeUrl) {
    _str = encodeURIComponent(_str);
  }
  _str = utils.xorStrings(cryptKey, _str);
  return utils.base64Encode(_str);
}

function foAjaxDecode(str, decodeUrl = true) {
  let _str = utils.base64Decode(str);
  _str = utils.xorStrings(cryptKey, _str);
  if (decodeUrl) {
    _str = decodeURIComponent(_str);
  }
  return JSON.parse(_str);
}

window.foAjaxEncode = foAjaxEncode;
window.foAjaxDecode = foAjaxDecode;
export { foAjaxEncode, foAjaxDecode };



// WEBPACK FOOTER //
// ./src/api/ajaxCrypt.js